import { render, staticRenderFns } from "./PtPrivacyPolicy.vue?vue&type=template&id=640c7227&scoped=true"
import script from "./PtPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PtPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "640c7227",
  null
  ,true
)

export default component.exports